/**
 * 后台共享小组件（M2 管理页共用）：状态徽标 / 状态筛选条 / 加载与错误块 / 预览抽屉链接。
 * 样式统一走 admin global.css 的 .mgr-* 类（07 后台样式基调：深色表面 + 细线）。
 */
import type { ReactNode } from 'react';

export function StatusBadge({ status }: { status: string }) {
  const label =
    status === 'PUBLISHED' ? '已发布' : status === 'OFFLINE' ? '已下线' : '草稿';
  return <span className={`mgr-badge mgr-badge--${status.toLowerCase()}`}>{label}</span>;
}

export function PageHeader({
  title,
  actions,
  sub,
}: {
  title: string;
  sub?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className='mgr-pagehead'>
      <div>
        <h1 style={{ fontFamily: 'var(--serif)', fontSize: 22, margin: 0 }}>{title}</h1>
        {sub && <p style={{ margin: '2px 0 0', fontSize: 13, color: 'var(--muted)' }}>{sub}</p>}
      </div>
      {actions && <div className='mgr-pagehead__actions'>{actions}</div>}
    </div>
  );
}

export function ErrorNote({ message }: { message: string }) {
  return (
    <p role='alert' className='mgr-error'>
      <span aria-hidden='true'>✎ </span>
      {message}
    </p>
  );
}

export function Loading({ text = '加载中…' }: { text?: string }) {
  return <p style={{ color: 'var(--muted)', fontSize: 14 }}>{text}</p>;
}

/** 表格容器（横向滚动兜底——移动端不破版） */
export function TableWrap({ children }: { children: ReactNode }) {
  return (
    <div style={{ overflowX: 'auto' }}>
      <table className='audit-table'>{children}</table>
    </div>
  );
}
